import React, { useState, ReactElement, useEffect, useReducer, useRef, ReactNode } from 'react';
import { CarouselWrapper, Dot, DotsContainer, SlidesTrack } from './styles';
import { scrollToElementHorizontally } from '@utils/scrollUtils';


interface GenericCarouselProps {
    totalSlides: ReactElement[];
}

const GenericCarousel: React.FC<GenericCarouselProps> = ({ totalSlides }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [slides, setSlides] = useState(totalSlides)
    const slidesRef = useRef<HTMLDivElement[]>([])
    const sliderContainerRef = useRef<HTMLDivElement | null>(null)

    if (!slides || slides.length === 0) {
        return <div style={{ textAlign: 'center', padding: '50px' }}>No slides provided.</div>;
    }

    useEffect(() => {
        const sliderInterval = setInterval(() => {
            setActiveIndex((ac) => ((ac + 1) % slides.length))
        }, 5000)
        return () => {
            clearInterval(sliderInterval)
        }
    }, [])

    useEffect(() => {
        if (slidesRef.current[activeIndex] && slidesRef.current[activeIndex].scrollIntoView instanceof Function && sliderContainerRef.current) {
            scrollToElementHorizontally(sliderContainerRef.current, slidesRef.current[activeIndex])
        }
    }, [activeIndex])

    return (
        <>
            <CarouselWrapper ref={sliderContainerRef}>
                <SlidesTrack $activeIndex={activeIndex} $slideCount={slides.length}>
                    {slides.map((slide, index) => (
                        //@ts-ignore
                        <div key={index} ref={(el) => (slidesRef.current[index] = el)} $activeIndex={activeIndex} id={index}>
                            {slide}
                        </div>
                    ))}
                </SlidesTrack>
            </CarouselWrapper>
            <DotsContainer>
                {slides.map((_, index) => (
                    <Dot
                        key={index}
                        $active={index === activeIndex}
                        onClick={() => setActiveIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                        role="button"
                    />
                ))}
            </DotsContainer>
        </>
    );
};

export default GenericCarousel;